import './polyfills/polyfills';
import Alpine from 'alpinejs';
import Collapse from '@alpinejs/collapse';
import Intersect from '@alpinejs/intersect';
import Slide from './alpine/directives/slide';
import Navigation from './components/navigation';
import Carousel from './components/carousel';
import './modules/lightbox';
import { AjaxRequest, AjaxMethod, AjaxResponseType } from './modules/ajax';
import { Lightbox, LightboxType } from './modules/lightbox';
import './extensions/object';
import Maps from './components/maps';
import PrivacyPolicy from './components/privacypolicy';
import Forms from './components/forms';
import AnimatedCounter from './components/animatedcounter';
import Swiper from 'swiper';
Alpine.plugin(Slide);
Alpine.plugin(Intersect);
Alpine.plugin(Collapse);
window.Alpine = Alpine;
window.Swiper = Swiper;
Alpine.data('overlayMenu', () => ({
    open: false,
    toggleMenu(open) {
        this.open = open != undefined ? open : (this.open == true ? false : true);
        if (this.open == false) {
            this.dropdownOpen = "";
        }
    },
    dropdownOpen: '',
    get dropdownOpenPath() {
        let path = [];
        let ids = this.dropdownOpen.split("/");
        let temp = "";
        ids.forEach((e) => {
            temp += e;
            path.push(temp);
            temp += "/";
        });
        return path;
    },
    isDropdownOpen(id) {
        let paths = this.dropdownOpenPath;
        for (let i = 0; i < paths.length; i++) {
            if (paths[i] == id) {
                return true;
            }
        }
        ;
        return false;
    },
    toggleDropdown(id) {
        if (this.dropdownOpen == id) {
            if (this.dropdownOpen.lastIndexOf("/") > -1) {
                this.dropdownOpen = this.dropdownOpen.substring(0, this.dropdownOpen.lastIndexOf("/"));
            }
            else {
                this.dropdownOpen = "";
            }
        }
        else {
            this.dropdownOpen = id;
        }
    }, init() { }
}));
Alpine.data('sideMenu', () => ({
    open: false,
    toggleMenu(open) {
        this.open = open != undefined ? open : (this.open == true ? false : true);
        if (this.open == false) {
            this.dropdownOpen = "";
        }
    },
    dropdownOpen: '',
    get dropdownOpenPath() {
        let path = [];
        let ids = this.dropdownOpen.split("/");
        let temp = "";
        ids.forEach((e) => {
            temp += e;
            path.push(temp);
            temp += "/";
        });
        return path;
    },
    isDropdownOpen(id) {
        let paths = this.dropdownOpenPath;
        for (let i = 0; i < paths.length; i++) {
            if (paths[i] == id) {
                return true;
            }
        }
        ;
        return false;
    },
    toggleDropdown(id) {
        if (this.dropdownOpen == id) {
            if (this.dropdownOpen.lastIndexOf("/") > -1) {
                this.dropdownOpen = this.dropdownOpen.substring(0, this.dropdownOpen.lastIndexOf("/"));
            }
            else {
                this.dropdownOpen = "";
            }
        }
        else {
            this.dropdownOpen = id;
        }
    }
}));
Alpine.start();
class Main {
    constructor() {
        var _a, _b, _c;
        this.HeaderDefaultTheme = [];
        this.HeaderTransparentTheme = [];
        var self = this;
        //new SVG();
        new Navigation();
        new Carousel();
        new Maps();
        new PrivacyPolicy();
        new Forms();
        new AnimatedCounter();
        this.lightboxes();
        this.embed();
        this.ajaxPaging();
        if (window["AOS"])
            window["AOS"].init();
        self.Footer = document.getElementById("footer");
        self.Header = document.getElementById("header");
        self.Main = document.getElementById("wrapper");
        let hasRichModule = (_c = (_b = (_a = self.Main.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains("rich-module")) !== null && _c !== void 0 ? _c : false;
        let transparentHeader = document.body.classList.contains("transparent-header");
        if (hasRichModule) {
            document.body.classList.add("has-rich-module");
        }
        else {
            document.body.classList.remove("transparent-header");
        }
        var headerHeight = self.Header.offsetHeight;
        if (headerHeight > 100)
            headerHeight = 100;
        self.sizeCheck();
        window.addEventListener("scroll", function () {
            if (window.pageYOffset > headerHeight) {
                document.body.classList.add("is-scrolled");
            }
            else {
                document.body.classList.remove("is-scrolled");
            }
        });
        self.convertImages();
        window.dispatchEvent(new CustomEvent("Bearbone::Initialized", {}));
    }
    convertImages(callback = null) {
        const images = document.querySelectorAll('img[src*=".svg"]');
        console.log(images);
        images.forEach(image => {
            fetch(image.getAttribute("src"))
                .then(res => res.text())
                .then(data => {
                const parser = new DOMParser();
                const svg = parser.parseFromString(data, 'image/svg+xml').querySelector('svg');
                if (image.id)
                    svg.id = image.id;
                if (image.className)
                    svg.classList.value = image.classList.value;
                image.parentNode.replaceChild(svg, image);
            })
                .then(callback)
                .catch(error => console.error(error));
        });
    }
    sizeCheck() {
        let self = this;
        document.addEventListener("DOMContentLoaded", function (event) {
            self.checkSize();
        });
        window.onresize = () => {
            self.checkSize();
        };
        Promise.all(Array.from(document.images)
            .filter(img => !img.complete)
            .map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
            self.checkSize();
        });
        var observer = new MutationObserver(function () {
            self.checkSize();
        });
    }
    checkSize() {
        if (this.Footer) {
            let footerSize = this.Footer.getBoundingClientRect();
            document.body.style.setProperty('--footer-height', Math.round(footerSize.height) + "px");
            document.body.style.setProperty('--footer-width', Math.round(footerSize.width) + "px");
        }
        if (this.Header) {
            let headerSize = this.Header.getBoundingClientRect();
            document.body.style.setProperty('--header-height', Math.round(headerSize.height) + "px");
            document.body.style.setProperty('--header-width', Math.round(headerSize.width) + "px");
        }
        document.body.classList.toggle("floating-footer", document.body.clientHeight <= window.innerHeight);
    }
    lightboxes() {
        let anchors = document.querySelectorAll(".lightbox");
        anchors.forEach(item => {
            item.lightBox({ disableScrollOnOpen: true });
        });
    }
    embed() {
        var embeds = document.querySelectorAll(".embed");
        if (embeds.length > 0) {
            embeds.forEach(embed => {
                let data = JSON.parse(embed.getAttribute("data-options"));
                let holder = embed.querySelector(".holder");
                let anchor = embed.querySelector("a");
                if (anchor != null) {
                    anchor.addEventListener("click", (e) => {
                        e.preventDefault();
                        open(data, holder, anchor);
                    });
                }
                else {
                    open(data, holder, anchor);
                }
            });
        }
        function open(data, holder, anchor) {
            if (data.lightbox) {
                let url = "/Blocks/Embed?" + Object.param({ url: data.url, width: data.width, height: data.height });
                let lightbox = new Lightbox({ disableScrollOnOpen: false, width: data.width, height: data.width, type: LightboxType.AJAX, href: url });
                lightbox.open();
            }
            else {
                let ajax = new AjaxRequest();
                ajax.Send(AjaxMethod.GET, "/Blocks/Embed", { url: data.url, width: data.width, height: data.height }, { ResponseType: AjaxResponseType.TEXT }).then(results => {
                    holder.innerHTML = results.data;
                    holder.classList.remove("hidden");
                    holder.classList.add("open");
                    if (anchor)
                        anchor.remove();
                }, error => {
                });
            }
        }
    }
    inViewport(element, options = { offset: { top: 0, right: 0, bottom: 0, left: 0 }, threshold: 0 }) {
        const { top, right, bottom, left, width, height } = element.getBoundingClientRect();
        const intersection = {
            t: bottom,
            r: window.innerWidth - left,
            b: window.innerHeight - top,
            l: right
        };
        const threshold = {
            x: options.threshold * width,
            y: options.threshold * height
        };
        return intersection.t > (options.offset.top + threshold.y)
            && intersection.r > (options.offset.right + threshold.x)
            && intersection.b > (options.offset.bottom + threshold.y)
            && intersection.l > (options.offset.left + threshold.x);
    }
    ajaxPaging() {
        let buttons = document.querySelectorAll(".ajax-paging");
        if (buttons.length > 0) {
            buttons.forEach((button, key) => {
                let parameters = getParameters(button);
                if (parameters.page >= parameters.pages) {
                    button.remove();
                }
                button.addEventListener("click", (e) => {
                    e.preventDefault();
                    load(e.target);
                });
            });
        }
        function getParameters(button) {
            let data = button.getData();
            return {
                url: button.getAttribute("href"),
                target: data.target,
                page: parseInt(data.page),
                pages: parseInt(data.pages)
            };
        }
        function load(button) {
            button.setAttribute("disabled", "disabled");
            let parameters = getParameters(button);
            let ajax = new AjaxRequest();
            ajax.Send(AjaxMethod.GET, parameters.url, { page: parameters.page + 1 }).then(results => {
                let holder = document.querySelector(parameters.target);
                holder.innerHTML += results.data;
                if (parameters.page + 1 >= parameters.pages) {
                    button.remove();
                }
                else {
                    button.setData("index", parameters.page + 1);
                }
                button.removeAttribute("disabled");
            }, error => {
                button.removeAttribute("disabled");
            });
        }
    }
}
window["Main"] = new Main();
